import {
    addCheckPerm,
    startCheckPerm,
    updateCheckPermCount,
} from '../actions/permissionCheckerInternalActions';
import getPermissionCheckerInfo from '../selectors/getPermissionCheckerInfo';
import { orchestrator } from 'satcheljs';

orchestrator(startCheckPerm, actionMessage => {
    const permissionCheckerInfo = getPermissionCheckerInfo(actionMessage.composeId);

    if (permissionCheckerInfo) {
        updateCheckPermCount(actionMessage.composeId, 1 /* count */);
    } else {
        addCheckPerm(actionMessage.composeId);
    }
});
